import { useQuery } from '@fv/client-core'

import { shipperFetch } from '@/utils/shipperFetch'

import type { AccountUserListingDTO } from './types'

export const accountUserKeys = {
  all: ['account-users'],
}

export const useAccountUsers = (enabled = true) => {
  return useQuery(
    accountUserKeys.all,
    () => shipperFetch<AccountUserListingDTO[]>(`/account-users`),
    {
      enabled,
    },
  )
}

export const useCheckRecentApiUsage = (
  userId: string,
  enabled: boolean = false,
) => {
  return useQuery(
    ['account-users', userId, 'recent-api-usage'],
    () =>
      shipperFetch<{ recentApiUsage: Date }>(
        `/account-users/${userId}/recent-api-usage`,
      ),
    {
      enabled,
    },
  )
}
